<template>
  <div>
    <v-select class="country-select geo-dropdown" :searchable="false" :clearable="false" :value="selectedCountry" :selected="'GX'" :options="countries" label="name" @input="countrySelect">
      <template v-slot:option="country">
        <img class="select-flag ls-is-cached lazyloaded" :src="country.flag">
        <span class="select-text">{{country.name}} <span class="language">{{ country.language_label }}</span></span>
      </template>

      <template v-slot:selected-option="country">
        <img class="select-flag ls-is-cached lazyloaded" :src="country.flag">
        <span class="select-text">{{country.name}} <span class="language">{{ country.language_label }}</span></span>
      </template>

      <template v-slot:open-indicator="{ attributes }">
        <span class="select-indicator" v-bind="attributes"></span>
      </template>
    </v-select>

    <v-select class="region-select geo-dropdown searchable-input" :clearable="false"  v-if="isCountryWithRegions()" label="name" :options="regionOptions" :value="selectedRegion" @input="regionSelect" style="cursor: pointer">
      <template v-slot:search="{ attributes, events }">
        <div class="input-wrapper">
          <input
              class="vs__search custom-search"
              v-bind="attributes"
              v-on="events"
              :placeholder="'Search'"
          />
        </div>
      </template>

      <template v-slot:option="region">
        <img class="select-flag ls-is-cached lazyloaded" v-if="region.flag.length" :src="region.flag">
        <span class="select-text">{{region.name}}</span>
      </template>

      <template v-slot:selected-option="region">
        <img class="select-flag ls-is-cached lazyloaded" v-if="region.flag.length" :src="region.flag">
        <span class="select-text">{{region.name}}</span>
      </template>

      <template v-slot:open-indicator="{ attributes }">
        <span class="select-indicator" v-bind="attributes"></span>
      </template>
    </v-select>
  </div>
</template>

<script>
export default {
  name: 'selector',
  props: {
    countries: {
      type: Array,
      default: [],
    },
    regions: {
      type: Object,
      default: {},
    },
    regionFlags: {
      type: Object,
      default: {},
    },
    activeCountryCode: {
      type: String,
      default: '',
    },


  },
  data: function () {
    return {
      selectedCountry: this.countries[0],
      selectedRegion: null,
      regionOptions: [],
    }
  },
  computed: {
    data: function(){
      return [];
    },
  },
  beforeMount() {
    //Remove Ontario from Canada for compliance
    this.regions['CA'].supported_regions = this.regions['CA'].supported_regions.filter(region => region.code !== 'ON');
    this.regions['CA-FR'].supported_regions = this.regions['CA-FR'].supported_regions.filter(region => region.code !== 'ON');
  },
  mounted: function () {
      this.setActiveGeoMainMenu();
  },
  methods: {
    countrySelect(value) {
      this.selectedRegion = '';
      this.selectedCountry = value;
      const selectedCountryCode = value.code.toUpperCase();

      if (selectedCountryCode === 'GX') {
        window.location = '/';
      }

      if (!this.isCountryWithRegions()) {
        this.hideModal();
        const path = window.location.pathname === '/news' ? 'path_news' : 'path';
        let desiredUrl = this.selectedCountry[path];
        this.prepareCaFrURL(desiredUrl);
      } else {
        this.prepareRegions(selectedCountryCode);

        this.selectedRegion = this.regionOptions[0];
      }
    },
    regionSelect(value) {
      this.selectedRegion = value;
      // this.selectedRegion = this.regions.find(region => region.code === value.code);
      this.setRegionCookie();
      this.hideModal();

      const urlParams = new URLSearchParams(window.location.search);
      urlParams.set('country', this.selectedCountry.code.toUpperCase());
      urlParams.set('regionCode', this.selectedRegion.code.toUpperCase());

      const path = window.location.pathname === '/news' ? 'path_news' : 'path';
      let desiredUrl = this.selectedCountry[path] + '?' + urlParams;

      // // if current page is selected geo - only refresh with new region info
      // let currentUrl = window.location.href.split('?')[0];
      // if (currentUrl.includes(this.selectedCountry.path)) {
      //   desiredUrl = desiredUrl + '?' + urlParams;
      // }
      if (this.activeCountryCode === this.selectedCountry.code.toUpperCase()) {
        desiredUrl = window.location.pathname.split('?')[0] + '?' + urlParams;
      }

      this.prepareCaFrURL(desiredUrl);
    },
    hideModal() {
      if (document.querySelector('.micromodal-slide')) {
        MicroModal.close('modal-global-selector');
      } else {
        $('#languageMenu').modal('hide');
      }
    },
    isCountryWithRegions() {
      return Object.keys(this.regions).includes(this.selectedCountry.code.toUpperCase());
    },
    setRegionCookie() {
      $cookies.set('op_list_region_' + this.selectedCountry.code.toLowerCase(), this.selectedRegion.code);
      if (this.selectedCountry.code.toUpperCase() === 'us') {
        $cookies.set('op_list_state', selectedRegion.code);
      }
    },
    setActiveGeoMainMenu() {
      const path = window.location.pathname;
      if (path === '/news') {
        this.activeCountryCode = 'GX';
      }
      this.initActiveCountry();
      if (this.isCountryWithRegions()) {
        this.initActiveRegion();
      }

      this.setActiveGeoMainMenuLabel();
    },
    setActiveGeoMainMenuLabel() {
      const region = this.isCountryWithRegions() ? this.selectedRegion : this.selectedCountry;

      document.querySelector('.geo-wrapper .geo-text').innerHTML = region.name.length > 14 ? region.code : region.name;
      document.querySelector('.geo-wrapper .geo-code').innerHTML = region.code.toUpperCase() === 'GB' ? 'UK' : region.code.toUpperCase();
      document.querySelector('.geo-wrapper .nav-flag').style.backgroundImage = "url('"+ region.flag +"')";
    },
    initActiveCountry() {
      let code = 'GX';
      if (this.activeCountryCode) {
        code = this.activeCountryCode;
      } else if (document.querySelector('html').dataset.ipcountry) {
        code = document.querySelector('html').dataset.ipcountry.toUpperCase();
      }

      this.selectedCountry = this.countries.find(country => country.code.toUpperCase() === code);
      if (this.isCountryWithRegions()) {
        this.regionOptions = this.regions[this.selectedCountry.code.toUpperCase()].supported_regions;
      }
    },
    initActiveRegion() {
      let regionCode = getCookie("op_list_region_" + this.selectedCountry.code.toLowerCase());
      if (!regionCode) {
        if (this.selectedCountry.code.toUpperCase() === 'US') {
          regionCode = 'NJ';
        } else if (this.selectedCountry.code.toUpperCase() === 'CA-FR') {
          regionCode = 'QC';
        } else {
          regionCode = 'AB';
        }
      }
      const countryRegions = this.regions[this.selectedCountry.code.toUpperCase()]['supported_regions'];
      this.prepareRegions(this.selectedCountry.code.toUpperCase());
      this.selectedRegion = countryRegions.find(region => region.code === regionCode);
    },
    prepareCaFrURL(desiredUrl) {
      if (this.selectedCountry.code.toUpperCase() === 'CA-FR') {
        window.location = desiredUrl.replace('ca-fr', 'ca/fr');
      } else {
        window.location = desiredUrl;
      }
    },
    prepareRegions(code) {
      this.regionOptions = this.regions[code].supported_regions.sort((a, b) => a.name.localeCompare(b.name));
      const defaultRegionOption = {
        code: '',
        name: '- Select -',
        flag: '',
      }
      const found = this.regionOptions.find(region => region.name === '- Select -');
      if (!found) {
        this.regionOptions.unshift(defaultRegionOption);
      }
    }
  }
};
</script>
